module.exports = __webpack_public_path__ + "img/logo_jre.abca1e69.jpg";